import React, { useCallback } from 'react';
import VariablesSelector from '../../../../components/EmailEditor/components/EditorToolbar/VariablesSelector';
import { Icon } from '@Sage/hoi-poi-ui';

const FieldInsertButton = ({ onChange }) => {
    const handleApply = useCallback(
        (variable) => {
            onChange?.({ value: variable });
        },
        [onChange],
    );

    return (
        <VariablesSelector onApply={handleApply}>
            <button type="button" className="textarea-field-insert__btn">
                <Icon name="variables" />
            </button>
        </VariablesSelector>
    );
};

FieldInsertButton.displayName = 'FieldInsertButton';
export default FieldInsertButton;
